"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get MetaDependencyModuleProvider () {
        return MetaDependencyModuleProvider;
    },
    get MetaDependencyServices () {
        return MetaDependencyServices;
    }
});
const _types = require("./types");
const _columntimezoneupdatehandler = require("~/services/meta-dependency/handler/column/column-timezone-update.handler");
const MetaDependencyServices = [
    _columntimezoneupdatehandler.ColumnTimezoneUpdateDependencyHandler
];
const MetaDependencyModuleProvider = {
    provide: _types.META_DEPENDENCY_MODULE_PROVIDER_KEY,
    useFactory: (...internalApiModules)=>internalApiModules,
    inject: MetaDependencyServices
};
